export default __webpack_public_path__ + "static/media/starter-pack-1.5b7387a9.png";